// client/src/components/auth/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function ProtectedRoute({ children }) {
  const { currentUser, loading, authRequired } = useAuth();
  
  // If auth check is in progress, show loading
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
        <div className="flex flex-col items-center">
          <div className="animate-spin h-12 w-12 border-4 border-blue-600 border-t-transparent rounded-full mb-4"></div>
          <p className="text-blue-600">Loading...</p>
        </div>
      </div>
    );
  }
  
  // If authentication is not required or user is logged in, render children
  if (!authRequired || currentUser) {
    return children;
  }
  
  // Otherwise redirect to login
  return <Navigate to="/login" />;
}